import Base from '../components/base/Index'
import List from '../components/base/List'
import Settings from '../components/base/Settings'
import Create from '../components/base/Create'
import Edit from '../components/base/Edit'

import {authGuard} from '../router/index'

const DefaultContainer = () => import('@/containers/DefaultContainer')
const HomeContainer = () => import('@/containers/HomeContainer')

import { cloneDeep } from 'lodash'

export async function setupComponents() {
  let defaultContainer = {
    path: '/admin/component',
    beforeEnter: authGuard,
    component: DefaultContainer,
    children: []
  }

  const claims = await this.$store.dispatch("fetchClaims")

  return new Promise((resolve, reject) => {
    this.$store.dispatch("fetchProjects").then(async (projects) => { 
      let currentProject = projects.find(p => {
        return p.uuid == claims.ProjectUUID
      })

      this.$store.commit("SET_CURRENT_PROJECT", currentProject)
      
      if (currentProject == null) {
        currentProject = projects[0]
      }

      let currentWorkspace = this.$store.getters.getCurrentWorkspace

      if (!currentWorkspace) {
        if (currentProject.workspaces !== null) {
          if (currentProject.workspaces.length < 1) {
            reject("noWorkspace")
          }

          this.$store.commit('SET_CURRENT_WORKSPACE', currentProject.workspaces[0])
        } else {
          reject("noWorkspace")
        }
      }
      
      this.$store.dispatch("fetchPermissions");
      this.$store.dispatch('fetchRoles');
      this.$store.dispatch("fetchApps");

        this.$store.dispatch("fetchComponentsMenu").then(comps => {
            if (comps !== null && comps.length > 0) {
              let setup = [];

              for(let i = 0; i < comps.length; i++) {
                  let el = comps[i];
                  //this.$store.dispatch("fetchComponentsSettings", el.uuid).then(r => {
                    let props = el.props

                    let name = el.displayName
                    if (!name) {
                      name = this.$translateLabel(el.label, el.name)
                    }

                    let path = el.name
                    let ref = el.name
                    if (el.scope) {
                      ref = `${el.scope}::${ref}`
                      path = `:scope/${path}`
                    }

                    props.id = ref
                    props.name = el.name

                    defaultContainer.children.push({
                      path: path,
                      name: el.name,
                      component: Base,
                      props,
                      meta: {
                        label: name,
                        ref
                      },
                      children: [
                        {
                          path: '',
                          name: el.name,
                          component: List,
                          //props: r.settings.list,
                          meta: {
                            label: `${name} ${this.$t('list')}`,
                            ref
                          }
                        },
                        {
                          path: 'create',
                          name: 'Create ' + el.name,
                          component: Create,
                          meta: {
                            label: `${name} ${this.$t('create')}`,
                            ref
                          }
                        },
                        {
                          path: 'edit/:uuid',
                          name: 'Edit '  + el.name,
                          component: Edit,
                          meta: {
                            label: `${name} ${this.$t('edit')}`,
                            ref
                          }
                        },
                        {
                          path: 'settings',
                          name: 'Settings',
                          component: Settings,
                          children: [],
                          props: {
                            id: ref
                          },
                          meta: {
                            label: `${name} ${this.$t('settings')}`
                          }
                        }
                      ]
                    })

                    setup.push(el)

                    if (defaultContainer.children.length == comps.length) {
                      const homeDefaultContainer = cloneDeep(defaultContainer)
                      homeDefaultContainer.path = "/home/component"
                      homeDefaultContainer.component = HomeContainer

                      this.$router.addRoutes([defaultContainer, homeDefaultContainer])

                      console.log("DEFAULT CONTAINER", defaultContainer)
                    }
                  // }).catch(err => {
                  //     reject(err);
                  // })
              }

              resolve(['componentsDidSetup', setup])
            } else {
              resolve(['noComponents'])
            }
        }).catch(err => {
          this.$debugLog(err)
          reject(err);
        })
    }).catch(err => {
      this.$debugLog(err)
      reject(err)
    })
  });
}